import {
    SIGNATORY1_FETCH_START,
    SIGNATORY1_FETCH_DONE,
    SIGNATORY1_FETCH_ERROR,
    SIGNATORY1_IMAGES,
    SIGNATORY2_FETCH_START,
    SIGNATORY2_FETCH_DONE,
    SIGNATORY2_FETCH_ERROR,
    SIGNATORY2_IMAGES,
    REPRESENTATIVE1_FETCH_START,
    REPRESENTATIVE1_FETCH_DONE,
    REPRESENTATIVE1_FETCH_ERROR,
    REPRESENTATIVE1_IMAGES,
    REPRESENTATIVE2_FETCH_START,
    REPRESENTATIVE2_FETCH_DONE,
    REPRESENTATIVE2_FETCH_ERROR,
    REPRESENTATIVE2_IMAGES,
    CUSTODIAN1_FETCH_START,
    CUSTODIAN1_FETCH_DONE,
    CUSTODIAN1_FETCH_ERROR,
    CUSTODIAN1_IMAGES,
    CUSTODIAN2_FETCH_START,
    CUSTODIAN2_FETCH_DONE,
    CUSTODIAN2_FETCH_ERROR,
    CUSTODIAN2_IMAGES,
    VERIFIER_FETCH_START,
    VERIFIER_FETCH_DONE,
    VERIFIER_FETCH_ERROR,
    VERIFIER_IMAGES,
    AUTHORIZER_FETCH_START,
    AUTHORIZER_FETCH_DONE,
    AUTHORIZER_FETCH_ERROR,
    AUTHORIZER_IMAGES,
    RESET_INTENT_USER_IMAGES
} from '../constants/ActionTypes';

const INIT_STATE = {
    signatoryOneImages: {
        status: "idle",
        data: null,
        error: null
    },
    signatoryTwoImages: {
        status: "idle",
        data: null,
        error: null
    },
    representativeOneImages: {
        status: "idle",
        data: null,
        error: null
    },
    representativeTwoImages: {
        status: "idle",
        data: null,
        error: null
    },
    custodianOneImages: {
        status: "idle",
        data: null,
        error: null
    },
    custodianTwoImages: {
        status: "idle",
        data: null,
        error: null
    },
    verifierImages: {
        status: "idle",
        data: null,
        error: null
    },
    verifierImages: {
        status: "idle",
        data: null,
        error: null
    },
    authorizerImages: {
        status: "idle",
        data: null,
        error: null
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SIGNATORY1_FETCH_START: {
            return {
                ...state,
                signatoryOneImages: {
                    ...state['signatoryOneImages'], status: 'loading'
                }
            };
        }

        case SIGNATORY1_FETCH_DONE: {
            return {
                ...state,
                signatoryOneImages: {
                    ...state['signatoryOneImages'], status: 'idle'
                }
            };
        }

        case SIGNATORY1_FETCH_ERROR: {
            return {
                ...state,
                signatoryOneImages: {
                    ...state['signatoryOneImages'], error: action.payload
                }
            };
        }
        case SIGNATORY1_IMAGES: {
            return {
                ...state,
                signatoryOneImages: {
                    ...state['signatoryOneImages'], data: action.payload
                }
            };
        }

        case SIGNATORY2_FETCH_START: {
            return {
                ...state,
                signatoryTwoImages: {
                    ...state['signatoryTwoImages'], status: 'loading'
                }
            };
        }

        case SIGNATORY2_FETCH_DONE: {
            return {
                ...state,
                signatoryTwoImages: {
                    ...state['signatoryTwoImages'], status: 'idle'
                }
            };
        }

        case SIGNATORY2_FETCH_ERROR: {
            return {
                ...state,
                signatoryTwoImages: {
                    ...state['signatoryTwoImages'], error: action.payload
                }
            };
        }
        case SIGNATORY2_IMAGES: {
            return {
                ...state,
                signatoryTwoImages: {
                    ...state['signatoryTwoImages'], data: action.payload
                }
            };
        }

        case REPRESENTATIVE1_FETCH_START: {
            return {
                ...state,
                representativeOneImages: {
                    ...state['representativeOneImages'], status: 'loading'
                }
            };
        }

        case REPRESENTATIVE1_FETCH_DONE: {
            return {
                ...state,
                representativeOneImages: {
                    ...state['representativeOneImages'], status: 'idle'
                }
            };
        }

        case REPRESENTATIVE1_FETCH_ERROR: {
            return {
                ...state,
                representativeOneImages: {
                    ...state['representativeOneImages'], error: action.payload
                }
            };
        }
        case REPRESENTATIVE1_IMAGES: {
            return {
                ...state,
                representativeOneImages: {
                    ...state['representativeOneImages'], data: action.payload
                }
            };
        }

        case REPRESENTATIVE2_FETCH_START: {
            return {
                ...state,
                representativeTwoImages: {
                    ...state['representativeTwoImages'], status: 'loading'
                }
            };
        }

        case REPRESENTATIVE2_FETCH_DONE: {
            return {
                ...state,
                representativeTwoImages: {
                    ...state['representativeTwoImages'], status: 'idle'
                }
            };
        }

        case REPRESENTATIVE2_FETCH_ERROR: {
            return {
                ...state,
                representativeTwoImages: {
                    ...state['representativeTwoImages'], error: action.payload
                }
            };
        }
        case REPRESENTATIVE2_IMAGES: {
            return {
                ...state,
                representativeTwoImages: {
                    ...state['representativeTwoImages'], data: action.payload
                }
            };
        }

        case CUSTODIAN1_FETCH_START: {
            return {
                ...state,
                custodianOneImages: {
                    ...state['custodianOneImages'], status: 'loading'
                }
            };
        }

        case CUSTODIAN1_FETCH_DONE: {
            return {
                ...state,
                custodianOneImages: {
                    ...state['custodianOneImages'], status: 'idle'
                }
            };
        }

        case CUSTODIAN1_FETCH_ERROR: {
            return {
                ...state,
                custodianOneImages: {
                    ...state['custodianOneImages'], error: action.payload
                }
            };
        }
        case CUSTODIAN1_IMAGES: {
            return {
                ...state,
                custodianOneImages: {
                    ...state['custodianOneImages'], data: action.payload
                }
            };
        }

        case CUSTODIAN2_FETCH_START: {
            return {
                ...state,
                custodianTwoImages: {
                    ...state['custodianTwoImages'], status: 'loading'
                }
            };
        }

        case CUSTODIAN2_FETCH_DONE: {
            return {
                ...state,
                custodianTwoImages: {
                    ...state['custodianTwoImages'], status: 'idle'
                }
            };
        }

        case CUSTODIAN2_FETCH_ERROR: {
            return {
                ...state,
                custodianTwoImages: {
                    ...state['custodianTwoImages'], error: action.payload
                }
            };
        }
        case CUSTODIAN2_IMAGES: {
            return {
                ...state,
                custodianTwoImages: {
                    ...state['custodianTwoImages'], data: action.payload
                }
            };
        }

        case VERIFIER_FETCH_START: {
            return {
                ...state,
                verifierImages: {
                    ...state['verifierImages'], status: 'loading'
                }
            };
        }

        case VERIFIER_FETCH_DONE: {
            return {
                ...state,
                verifierImages: {
                    ...state['verifierImages'], status: 'idle'
                }
            };
        }

        case VERIFIER_FETCH_ERROR: {
            return {
                ...state,
                verifierImages: {
                    ...state['verifierImages'], error: action.payload
                }
            };
        }
        case VERIFIER_IMAGES: {
            return {
                ...state,
                verifierImages: {
                    ...state['verifierImages'], data: action.payload
                }
            };
        }
        case AUTHORIZER_FETCH_START: {
            return {
                ...state,
                authorizerImages: {
                    ...state['authorizerImages'], status: 'loading'
                }
            };
        }

        case AUTHORIZER_FETCH_DONE: {
            return {
                ...state,
                authorizerImages: {
                    ...state['authorizerImages'], status: 'idle'
                }
            };
        }

        case AUTHORIZER_FETCH_ERROR: {
            return {
                ...state,
                authorizerImages: {
                    ...state['authorizerImages'], error: action.payload
                }
            };
        }
        case AUTHORIZER_IMAGES: {
            return {
                ...state,
                authorizerImages: {
                    ...state['authorizerImages'], data: action.payload
                }
            };
        }
        case RESET_INTENT_USER_IMAGES: {
            state = INIT_STATE
            return state;
        }
        default:
            return state;
    }
}
